import ReceiptVisual from './ReceiptVisual';

export default function Hero() {
  return (
    <section className="relative pt-16 pb-24 md:pt-20 md:pb-32 overflow-hidden">
      {/* Spray-paint blobs */}
      <div
        aria-hidden
        className="pointer-events-none absolute -top-20 -left-32 w-[420px] h-[420px] rounded-full opacity-20 blur-3xl"
        style={{ background: 'hsl(var(--accent))' }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute top-40 -right-20 w-[360px] h-[360px] rounded-full opacity-15 blur-3xl"
        style={{ background: 'hsl(var(--primary))' }}
      />

      <div className="container-ledger relative grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 mb-6 border-2 border-spray-magenta px-3 py-1 text-spray-magenta text-[11px] font-bold uppercase tracking-[0.18em]">
            <span aria-hidden className="w-1.5 h-1.5 bg-spray-magenta inline-block" />
            AI billing attribution
          </div>
          <h1 className="font-display text-5xl md:text-7xl leading-[0.95] uppercase">
            What did each client cost you in{' '}
            <span className="text-spray-yellow">AI</span> this month?
          </h1>
          <p className="mt-8 text-lg text-muted-foreground max-w-[58ch] leading-relaxed">
            Key Receipt is a billing-attribution proxy. Mint a token per client, point Claude
            Code, Cursor, or any BYO-key tool at us, and get an itemised receipt at month-end —
            defensible, exportable, ready for your invoice.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="/_auth/google/login"
              className="inline-flex items-center bg-spray-yellow text-primary-foreground font-bold px-7 py-4 text-base uppercase tracking-wide border-2 border-foreground hover:translate-x-[-2px] hover:translate-y-[-2px] transition-transform"
              style={{ boxShadow: '6px 6px 0 0 hsl(var(--foreground))' }}
            >
              Assert my costs →
            </a>
            <a
              href="#pricing"
              className="inline-flex items-center border-2 border-border text-foreground font-bold px-7 py-4 text-base uppercase tracking-wide hover:bg-muted transition-colors"
            >
              See pricing
            </a>
          </div>

          <div className="mt-6 text-xs text-muted-foreground font-mono uppercase tracking-wider">
            $5/mo solo · $20/mo agency · no token markup
          </div>
        </div>

        <div className="lg:col-span-5">
          <ReceiptVisual />
        </div>
      </div>
    </section>
  );
}
